import React from "react";

const HomeHero = () => (
    <div className="d-flex flex-column align-items-center justify-content-center main-hero my-5">
        <span className="icon-MadebyMade-Vector-LineIcons-Cafe-Outlined-13"></span>
        <h1 className="text-center">An archive of stuff we ate.</h1>
    </div>
)

export default HomeHero;